import VideoOverlayToolsIcon from '@atlaskit/icon-lab/core/video-overlay-tools';
import React from 'react';

export function SvgOverlays() {
  return <VideoOverlayToolsIcon label="" testId="ads-refreshed-icon" />;
}
